import React, { useContext } from "react"

import { RouteComponentProps } from "react-router-dom"
import { gql, useQuery } from "urql"

import NotFound from "~Tutor/Pages/NotFound"
import TutorContext from "~Tutor/TutorContext"
import EditSubjectBuckets from "~Tutor/components/TutorSubjects/EditSubjectBuckets"
import { H2, WithLoadingIndicator } from "~tailwindui/Basics"

import { MatchParams } from "src/types"

const EditTutorSubjects: React.FC<RouteComponentProps<MatchParams>> = ({
  match,
}) => {
  const tierId = match.params.id
  const { viewer } = useContext(TutorContext)
  const tutorId = viewer.id

  const [result] = useQuery({
    query,
    variables: { tutorId, tierId },
    requestPolicy: "network-only",
  })

  if (result.data && !result.data.tier) return <NotFound />

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { viewer, tier } }) => (
        <div className="flex flex-col items-center justify-center">
          <H2>Edit {tier.gradeRange} Subjects</H2>

          <EditSubjectBuckets tier={tier} viewer={viewer} />
        </div>
      )}
    </WithLoadingIndicator>
  )
}

const query = gql`
  query TutorSubjectBuckets($tutorId: ID!, $tierId: ID!) {
    viewer {
      id
      subjectBuckets(tierId: $tierId) {
        id
        name
        approvalState(tutorId: $tutorId)
      }
    }
    tier(id: $tierId) {
      id
      gradeRange
      subjectBuckets {
        id
        name
      }
    }
  }
`

export default EditTutorSubjects
